import {OriginalUserInterface} from "@/api/Partners/LoginAs/Interfaces/OriginalUserInterface";

const STORAGE_KEY = "inlabB2BOriginalUser";
const SYNC_KEY = STORAGE_KEY + '_sync';

class OriginalUserStorageService {
    public getFromStorage(): OriginalUserInterface | null {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (raw === null) {
                return null;
            }
            return JSON.parse(raw);
        } catch {
            return null;
        }
    }

    public setToStorage(user: OriginalUserInterface): void {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
        localStorage.setItem(SYNC_KEY, Date.now().toString());
    }

    public removeFromStorage(): void {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.setItem(SYNC_KEY, Date.now().toString());
    }

    public static onOriginalUserChanged(callback: () => void): () => void {
        const handler = (e: StorageEvent) => {
            if (e.key === SYNC_KEY) {
                callback();
            }
        };
        window.addEventListener('storage', handler);
        return () => window.removeEventListener('storage', handler);
    }
}

export {OriginalUserStorageService};
